import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchRevenueByNetwork,
  initializeRevenueByNetworkScreen,
  exportRevenueByNetwork,
  setRevenueByNetworkFilters,
  clearRevenueByNetworkFilters,
} from "../../../redux/actions/Reservations/RevenueByNetwork";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchRateAdminNetworkDD } from "../../../redux/actions/RateAdmin/rateadminRates";
import RevenueByNetwork from "../../../component/Reservations/RevenueByNetwork";
import { loadingShow } from "../../../services/PostAPI";
import { ProgressBar } from "primereact/progressbar";

let cachedFilters = null;

function RevenueByNetworkScreen(props) {
  const {
    fetchRevenueByNetwork,
    initScreen,
    RevenueByNetworkListview,
    paginationInfo,
    exportRevenueByNetwork,
    isExportError,
    isExportSuccess,
    isLoading,
    fetchLocationDD,
    fetchRateAdminNetworkDD,
    RateNetworkDD,
    locationDD,
    filters,
    setFilters,
    clearFilters,
    showPageLevelLoader,
  } = props;

  const setFiltersWithCache = (f) => {
    cachedFilters = f;
    setFilters(f);
  };

  useEffect(() => {
    fetchRateAdminNetworkDD();
    fetchLocationDD();
  }, []);

  useEffect(() => {
    initScreen();
  }, []);

  const loadLazyData = (payload) => {
    const newPayload = {
      ...payload,
      additinalFilter: payload.additinalFilter ?? cachedFilters,
    };
    fetchRevenueByNetwork(newPayload);
  };

  const handleExport = (payload) => {
    const exportPayload = {
      ...payload,
      additinalFilter: payload?.additinalFilter ?? cachedFilters,
    };
    exportRevenueByNetwork(exportPayload);
  };

  const componentProps = {
    fetchRevenueByNetwork: loadLazyData,
    exportRevenueByNetwork: handleExport,
    isExportError,
    isExportSuccess,
    tableData: {
      columns: RevenueByNetworkListview?.columns,
      rows: RevenueByNetworkListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    RateNetworkDD,
    locationDD,
    filters,
    setFilters: setFiltersWithCache,
    clearFilters,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      {isLoading && (
        <ProgressBar mode="indeterminate" style={{ height: "6px" }} />
      )}
      <RevenueByNetwork {...componentProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  initScreen: () => dispatch(initializeRevenueByNetworkScreen()),
  fetchRevenueByNetwork: (payload) =>
    dispatch(fetchRevenueByNetwork(payload)),
  fetchRateAdminNetworkDD: (payload) =>
    dispatch(fetchRateAdminNetworkDD(payload)),
  fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
  exportRevenueByNetwork: (payload) =>
    dispatch(exportRevenueByNetwork(payload)),
  setFilters: (f) => dispatch(setRevenueByNetworkFilters(f)),
  clearFilters: () => dispatch(clearRevenueByNetworkFilters()),
});

const mapStateToProps = (state) => ({
  isLoading: state.RevenueByNetworkReducer?.isLoading,
  RevenueByNetworkListview:
    state.RevenueByNetworkReducer?.RevenueByNetworkListview,
  showPageLevelLoader: state.RevenueByNetworkReducer?.isLoadingPage,
  paginationInfo: state.RevenueByNetworkReducer?.paginationInfo,
  isExportError: state.RevenueByNetworkReducer?.isExportError,
  isExportSuccess: state.RevenueByNetworkReducer?.isExportSuccess,
  RateNetworkDD: state.rateadminRatesReducer?.RateNetworkDD,
  locationDD: state.locationReducer?.locationDD,
  filters: state.RevenueByNetworkReducer?.filters,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RevenueByNetworkScreen);
